export default __webpack_public_path__ + "static/media/image.789d9e1a.png";